import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Inject, Injectable, LOCALE_ID, OnDestroy, PLATFORM_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router,  } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from "rxjs/internal/Subject";
import { catchError, map, take, takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Dividend } from "../models/dividend";
import { Page } from "../models/page";
import { SortData } from "../models/sort-data";
import { CanonicalService } from "../services/canonical.service";
import { DividendService } from "../services/dividend.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";
import { ErrorMsg } from "../utils/error-msg";

@Injectable({
    providedIn: 'root',
  })
  export class DividendStockResolver implements Resolve<any> ,OnDestroy{
    destroy$: Subject<boolean> = new Subject<boolean>();
    constructor(
      @Inject(LOCALE_ID) private localId: Object,
      @Inject(PLATFORM_ID) private platformId: Object,
      private canonicalService: CanonicalService,
      private dividendService:DividendService,
      private seoService:MetaSeoService,
      public jsonldService: JsonldService,
      private router: Router,
    ){}

    ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.unsubscribe();
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
      if (isPlatformBrowser(this.platformId)||isPlatformServer(this.platformId)) {
        const yearParam = route.paramMap.get('year');
        const codeParam = route.paramMap.get('code');
        const subSuffex="/dividend/stock/"+yearParam+"/"+codeParam
        const domain=environment.domain;
        const lang=(this.localId+"").substring(0,2);        
        let domainAndLangURL=domain+"/"+lang;
        let pageInfo = new Page();
        pageInfo.pageNumber = 1;
        pageInfo.size = 5;  
        let sortData=new SortData<Dividend>();
        let dividend = new Dividend();
        dividend.lang=this.localId as string;
        dividend.country=this.localId+"";
        dividend.startDate=new Date(Number(yearParam),0,0,0,0,0);
        dividend.endDate=new Date(Number(yearParam),11,0,23,59,59);
        dividend.url=codeParam;
        sortData.filter=dividend;
        sortData.sorts=[{"dir": "desc", "prop": "regstrDt"}]
        pageInfo.pageNumber = pageInfo.pageNumber - 1;
        return this.dividendService.getPageAbleList(pageInfo,sortData).pipe( 
          takeUntil(this.destroy$),
        map(pagedData => {
          if (!pagedData) {
            this.router.navigate(['/404']);
           }
           let d = pagedData.data[0] as Dividend;
           let title=this.getTitle(d,yearParam);
            let noIndex;
            let description= this.getDesc(d,yearParam);
            if(lang!="tr"){
              title=this.getTitle(d,yearParam);
              description=this.getDesc(d,yearParam);
            }
            let canonicalURL = domain+"/"+lang+subSuffex;
            this.canonicalService.setCanonicalURLForId(canonicalURL);      
            this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,noIndex);
            this.canonicalService.setOnlyAlternateDefault(canonicalURL);
            this.jsonldService.removeJsonSnippet();
            this.jsonldService.setOrganization();
          return pagedData;
        }),
        catchError(err => ErrorMsg.handleError(this.router,err))
        ) 
    }
  }

  getTitle(d,yearParam){
    let title =d.code +" Temettü "+yearParam+" | Halka Arz";
    return title;      
  }
  
  getDesc(d,yearParam){    
    let title =yearParam +" "+d?.code.toLowerCase() +" - " +d?.name?.toLowerCase() +" Hisse Temettü Detay Bilgileri, "+yearParam+" Temettü Veren Hisseler, Temettü Nedir, Önemli Temettü Tarihleri!";
    if(d?.name?.toLowerCase().includes(d?.code?.toLowerCase())){
      title =yearParam +" "+d?.code.toLowerCase()  +" Hisse Temettü Detay Bilgileri, "+yearParam+" Temettü Veren Hisseler, Temettü Nedir, Önemli Temettü Tarihleri!";
    }
    return title;      
  }
}
